{
  "0268986f0d48cdea": "No se pudieron cargar los requisitos. Por favor, inténtalo de nuevo.",
  "02a45e1aac74dc6d": "No se pudo actualizar el requisito previo.",
  "05fcc9f59a267872": "Requerimiento Postgres",
  "06e4d2977e7cd949": "¿Bloquear los mapeos de requisitos a ELIGIBILITY_ENGINE?",
  "1004a057d2b7267e": "ID de Mapeo",
  "10104f72c61f60fd": "Tipos de Lugar de Trabajo",
  "1031170aac0e2271": "(estándar desconocido)",
  "1331275bc537b4c2": "Etiquetas",
  "13ea0e4f9f8e5dff": "Error al actualizar la propiedad del mapeo.",
  "14391103278e53ff": "Requerimientos Vinculados",
  "1509f561f2416598": "Guardar",
  "18d67c992b71ce69": "Nombre para mostrar",
  "193e54a750c539da": "Falló al actualizar la definición de evidencia.",
  "19766ed6ccb2f4a3": "Cancelar",
  "1a83135d903dcd9e": "Definición de evidencia",
  "1bb2c8090cb4ec5e": "Creado {{date}}",
  "1c273344196fe0ba": "Todas las calificaciones",
  "1de9540a2246bab3": "Crear estándar",
  "1ff7e2672da736d7": "IDs de Lugar de Trabajo",
  "20ee055ad1ee378d": "Mapas de Requisitos",
  "21086aa64ca25c43": "No se pudieron cargar las asignaciones de requisitos. Por favor, inténtalo de nuevo.",
  "2167126e3368f142": "Sin prerrequisitos aún.",
  "24486e63f81dec5e": "No se pudo eliminar el requerimiento vinculado.",
  "2539b46db4b27709": "Editar Elegibilidad del Rol",
  "2aa9901daf6393f5": "Nombre del requisito",
  "2edb1386b3a284e6": "Editar estándar",
  "2f69284936541865": "Propiedad del mapeo",
  "2f6e9daec8e9b3b3": "Estados",
  "30401176dda39460": "Seleccionar tipos de lugar de trabajo",
  "324b134f57c70c72": "Vista previa",
  "324ddac12d893a7d": "Lugares de trabajo",
  "342ec60b8c1dff58": "Crear definición de evidencia",
  "35216c7957ee3dcd": "Falló al eliminar la definición de evidencia.",
  "356358348d9a0262": "Comience a escribir para buscar definiciones de evidencia",
  "3843971dcfdee508": "ID",
  "395e06accb3b958a": "Editar mapeo de requisitos",
  "3a17aa4e4abb73f6": "Etapas",
  "3c0ec5157717e41f": "Deje vacío para aplicar a todos los roles",
  "3c481ac202f78a62": "ID de lugar de trabajo: {{id}}",
  "3cc8ca5ee96f7abe": "Comience a escribir para buscar",
  "3d44337010bfbdf7": "Creado el",
  "3faaa28d5141b967": "ID de Requisito de Postgres:",
  "3fb1cfbfaa6ad97d": "Crear Mapeo de Requisitos",
  "415bee5a77bb8213": "Falló al eliminar el requisito.",
  "4327226d25f9321e": "Falló al crear el requisito.",
  "44c2b1dce3f01022": "Separados por comas (por ejemplo, CA, NY)",
  "44eee0ddd2f5ece7": "Editar definición de evidencia",
  "457a8abce0db81a9": "Falló al crear el estándar.",
  "463d8035a6f8d897": "(nodo no reconocido)",
  "464c4ffd019e1e96": "Editar",
  "4759498ac2a719c6": "Crear",
  "47d2a515ef2f05b8": "Cargando...",
  "48b3f715021f7de3": "Administrado por la lista blanca de campos del perfil — no editable aquí",
  "4916b049b37d0cb0": "Todos los tipos de lugar de trabajo",
  "4a0576c388cfaa8d": "ID de definición de evidencia",
  "4b6e9668124284db": "Comienza a escribir para buscar lugares de trabajo",
  "4c9f298046750451": "ObjectId de Mongo de 24 caracteres",
  "4e414af41b7d4876": "Contratación",
  "501e932291eb7554": "ObjectId hexadecimal de 24 caracteres de Mongo",
  "531c7b28abf27600": "Desbloqueado",
  "53ceaa5f5473b180": "Editar requisito",
  "57b184937623d3b1": "Falló al actualizar el requisito.",
  "5ac94805281790ee": "Formato JSON",
  "5ec4492ea240afdc": "ID de Requerimiento Mongo",
  "613f183e222fd273": "Falló al crear el mapeo de requisitos.",
  "61eed57adaf7affb": "Elija un requisito que el trabajador pueda completar por sí mismo antes de la presentación: una licencia, identificación personal o SSN, no una verificación posterior a la presentación.",
  "62219f0a0ed059e5": "Requerimiento desconocido",
  "6a143555e0c4af9b": "Editar elegibilidad del rol prerrequisito",
  "6e35e285106ad4a8": "Filtrar por nombre",
  "6e9a4c33b916d1a4": "No se encontraron definiciones de evidencia",
  "7065595e20295812": "Los mapeos para este requisito son gestionados por ELIGIBILITY_ENGINE. Desactiva para desbloquear.",
  "72ac0d580f8c4f9f": "Copiar ID",
  "72d8a700e51c8c0b": "{{count}} prerrequisitos",
  "73699fd80111c515": "Falló al crear la definición de evidencia.",
  "75f976a7fc65f13b": "Falló al actualizar el estándar.",
  "7785223c0510e454": "Falló al actualizar el mapeo de requisitos.",
  "78f133afd3ec55cd": "Todos los roles",
  "79fa33618d8eaa1f": "Dominio",
  "7b4339cf860e01a6": "Calificaciones",
  "7d6380f3d23b1eae": "¿Está seguro de que desea eliminar este prerrequisito?",
  "7e402d5eb3f3668f": "Bloqueado a ELIGIBILITY_ENGINE",
  "84453e47975d03d7": "Requiere Migración",
  "865514682d0132ab": "Prerrequisitos",
  "88bea99c51ccc355": "Buscando requisitos...",
  "891dc0c8b1ae8ae1": "Buscar por nombre o pegar IDs...",
  "89cf6f86f6c70fe8": "Elegibilidad del rol",
  "8a0e8b2844975daa": "Tipo de flujo de trabajo",
  "8ffcf3be035d00fe": "No se encontraron lugares de trabajo",
  "94837b24cef292b2": "Error al cargar los prerrequisitos. Por favor intente nuevamente.",
  "948e03e7054b919e": "Reservas",
  "94f64acd4fedf861": "Dejar vacío para aplicar a todos los estados",
  "973b69ab243b0d0a": "No se pudo crear el requerimiento vinculado.",
  "9c63821115600f5e": "Eliminar prerrequisito",
  "a397e25a902a7e8b": "Crear Prerrequisito",
  "a52ace420f2175d0": "Todo",
  "a7395282d1f50b89": "No se pudieron cargar los requerimientos vinculados. Por favor, inténtalo de nuevo.",
  "a7f54311a3e625f5": "Confirmar Eliminación",
  "a92f0449a9f7235b": "Trabajando",
  "ab6e1299d6517494": "Seleccionar calificaciones",
  "ac8991ef01019cf5": "Cargar más",
  "aef35920b0ee1fe4": "Crear requisito",
  "af0cc56d596d8af1": "¿Está seguro de que desea eliminar este mapeo de requisitos?",
  "af581b30eecddefc": "Falló al eliminar el mapeo de requisitos.",
  "b073f6c68ef87211": "Alcance",
  "b1c80bb5cebe85fa": "Seleccionar etapas",
  "b1ca9631468707fc": "Agregar prerrequisito a {{name}}",
  "b6fc64ca7c120613": "Eliminar requerimiento vinculado",
  "b764cdc0eab71374": "Desconocido",
  "b9a136292f4004e2": "Estándares",
  "ba3bbbe10d8bef66": "Cargando…",
  "bb90ab27103e16f0": "No se pudo crear el requisito previo.",
  "bc5078ce1707e013": "Eliminar mapeo de requisitos",
  "bc77090e3672e182": "Separados por comas",
  "be049398d39842a1": "No se encontraron requisitos",
  "be8a1a85b863acd4": "Filtrar por ID",
  "bfc08d08ea4b3844": "Mientras este requisito esté bloqueado, todos sus mapeos serán de solo lectura en la herramienta de administración y el backend rechazará cualquier intento de editarlos.",
  "c2c2a0c9cc69eb35": "(sin estándar seleccionado)",
  "c90910730b8f8383": "Esquema de propiedades",
  "c9404d3f3b44bbe2": "Editar Prerrequisito",
  "c9a6fb6ee34fe03a": "Reglas (ConditionTreeNode)",
  "c9f120c13bc3f754": "Normas (StandardsTreeNode)",
  "cc2111dd92b635db": "Buscando lugares de trabajo...",
  "cc90340ab604bf01": "¿Estás seguro de que deseas eliminar este requerimiento vinculado?",
  "cca10665298c5ef3": "Bloquear mapeos a ELIGIBILITY_ENGINE",
  "ceb6cf01cd811429": "Debe ser un ObjectId de Mongo de 24 caracteres",
  "d6aa831538edb7d5": "Crear Requerimiento Vinculado",
  "d70b9e24bca26b40": "Creado",
  "d74b42242108ea28": "Los mapeos para este requisito se pueden editar libremente. Activa para bloquear a ELIGIBILITY_ENGINE.",
  "db171459d454694f": "Este requisito tiene dependencias (prerrequisitos, enlaces o asignaciones) que deben ser eliminadas primero.",
  "db44b8db4f05d720": "Bloquear",
  "dcd1d5223f73b3a9": "Nombre",
  "df6c4d66b56964ae": "Aún no hay requerimientos vinculados.",
  "dfa9dfa5cad2d8f9": "Elegibilidad",
  "dfee897028a99bc1": "Prerrequisito eliminado.",
  "e04e01b4add9f48f": "p. ej. 65f2a1b3c4d5e6f7a8b9c0d1",
  "e092e70a533f66c5": "Falló al eliminar el estándar.",
  "e0cdd07f6a270b82": "Requisitos",
  "e2d0a54968ead24e": "Eliminar",
  "e2f79e5b60330bba": "N/A",
  "e35c8e4f5cb5c554": "Actualizado el",
  "e87ced5e089eba2b": "ID: {{id}}",
  "ea61bc15688d1e48": "¡Copiado!",
  "eaf5c28560a60857": "Prerrequisito",
  "ed71fe3a468e163d": "Buscando definiciones de evidencia...",
  "ed82cf60e617eb63": "Buscar por nombre...",
  "f02530118b8acd1f": "Editar Mapeo de Requisitos",
  "f0720d29ce24b75c": "Nombres de Calificaciones",
  "f189411452ed2860": "Todos los estados",
  "f5f5690b0ecc41d3": "Requisito",
  "f60c824125e6408e": "JSON Inválido",
  "f631b3b20df331d5": "Estado de bloqueo",
  "f8fb2c2f8b31f897": "Definiciones de Evidencia",
  "fbab5beefa17d573": "{{count}} enlaces",
  "fd59093451019cff": "No se pudo eliminar el requisito previo.",
  "fd5c7b4d434ccac3": "No se pudieron cargar los estándares. Por favor, inténtalo de nuevo.",
  "fea31386a31f34c6": "No se pudieron cargar las definiciones de evidencia. Por favor, inténtalo de nuevo.",
  "ff114b097c5db588": "Ingresa JSON válido para ver la vista previa"
}
